@use "src/sedestral/sass/mixins/texts";
@use "src/sedestral/sass/icons/icons";

.componentWebsiteBlackGuide {
  width: 100%;
  display: flex;
  gap: 30px;
  justify-content: space-between;

  .nav {
    width: 100%;
    border-right: 1px solid var(--grey-sur);
    max-width: 290px;
  }

  .article {
    width: 750px;
    flex: 0 0 750px;
    padding: 20px 0px 50px;
    position: relative;

    .progress {
      display: flex;
      align-items: center;
      gap: 10px;
      justify-content: center;
      margin-top: 45px;

      .button {
        background: var(--grey-sur);
        border-radius: 8px;
        color: var(--black);
        display: flex;
        font-size: 15px;
        padding: 12px 18px;
        align-items: center;
        gap: 8px;
        cursor: pointer;
        transition: 0.1s;

        @include texts.font("semi-bold");

        &:hover {
          background: var(--grey-sur-hover);
        }

        &.next {
          background: var(--web-blue-alpha);
          box-shadow: inset 0 0 0 2px var(--web-blue);
          color: var(--web-blue);

          .icon {
            filter: var(--icon-web-blue);

            @include icons.ico("black-right-arrow");
          }

          &:hover {
            background: var(--web-blue);
            color: var(--white);

            .icon {
              filter: var(--icon-white);
            }
          }
        }

        .icon {
          width: 14px;
          height: 14px;
          filter: var(--icon-black);

          @include icons.ico("black-left-arrow");
        }
      }
    }
  }

  .details {
    width: 100%;
    max-width: 310px;
    padding: 35px 25px 25px 25px;
    position: relative;
  }

  @media screen and (max-width: 1370px) {
    .article {
      width: calc(100% - 40px) !important;
      flex: unset !important;
    }
  }

  @media screen and (max-width: 480px) {
    flex-direction: column;
    gap: 0;

    .nav {
      border-right: unset;
      order: 0;
      max-width: unset;
    }

    .details {
      order: -1;
      border-bottom: 1px solid var(--grey-sur);
      padding: 25px 15px 0px;
    }

    .article {
      flex: unset;
      width: unset;
      padding: 20px;
      border-bottom: 1px solid var(--grey-sur);
      order: -2;
    }
  }
}